import { useEffect, useState } from 'react';
import { GetAppData, getComponentDependenciesByComponent } from 'pages/ApplicationMaintenance/_api';
import { Button } from '@upmc/ims.component-library';
import styles from '../../../../ApplicationMaintenance.module.scss';
import Base from '../../../../../Base/Base';
import Modal from '@mui/material/Modal';
import MaterialIcon from '@material/react-material-icon';
import ComponentDependencyDisplay from './components/ComponentDependencyDisplay';
import { AppData, ComponentDependency } from 'Classes/ResponseModels/ApplicationManagement/AppManagementModel';

const ComponentDependencyManagement = ({
	component,
	app,
	currentUser,
	reload,
	readOnly,
	requirementNumber,
}) => {
	const [modalOpen, setModalOpen] = useState(false);
	const [sComponent, setComponent] = useState(component);
	const [sLoading, setLoading] = useState(false);
	
	useEffect(() => {
		const load = async () => {
			setLoading(true);
			let componentCopy = { ...sComponent };
			const arrAppData = await GetAppData(sComponent?.id);
			componentCopy.appData = arrAppData.map(data => new AppData(data));
			const arrDeps = await getComponentDependenciesByComponent(
				componentCopy?.id
			);
			componentCopy.componentDependencies = arrDeps.map(
				dep => new ComponentDependency(dep)
			);
			setComponent(componentCopy);
			setLoading(false);
		};
		if (modalOpen) {
			load();
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [modalOpen]);

	return (
		<div>
			<div>
				<div className={styles.controlsContainer}>
					<Button
						id='app_ComponentDependencyForm_modal_open'
						onClick={() => setModalOpen(true)}
						startIcon={<MaterialIcon icon='edit' />}
						sx={{ mb: '.5em' }}
					>
						{readOnly ? 'View Dependencies' : 'Edit Dependencies'}
					</Button>
				</div>
				<Modal
					open={modalOpen}
					onClose={() => {
						setModalOpen(false);
						reload();
					}}
				>
					<div className={styles.Modal}>
						<Base title='Component Dependencies' loading={sLoading}>
							<ComponentDependencyDisplay
								component={sComponent}
								app={app}
								currentUser={currentUser}
								reload={reload}
								readOnly={readOnly}
								requirementNumber={requirementNumber}
							/>
						</Base>
					</div>
				</Modal>
			</div>
		</div>
	);
};

export default ComponentDependencyManagement;
